// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2bz8m","header":"MergedInvoice_header__RamVe"};